import { memo, type PropsWithChildren } from "react"

import { useMapLoad } from "../hooks"

export const MapLoadGuard = memo<PropsWithChildren>((props) => {
	const { children } = props

	const [loaded, styleLoaded] = useMapLoad()

	return loaded && styleLoaded && children
})
MapLoadGuard.displayName = "MapLoadGuard"
